import queryString from "query-string";
import Alert from "react-s-alert";
import TrialCoachingSessionsService from "../utils/TrialCoachingSessionsService";

class TCSActions {
  constructor(deal, handleDealUpdated, authStore) {
    this.deal = deal;
    this.handleDealUpdated = handleDealUpdated;
    this.authStore = authStore;
  }

  handleDealUpdate = response => {
    if (this.handleDealUpdated) this.handleDealUpdated(response);
  };

  bookTCS = booking_from => {
    const deal = this.deal;
    const profile = this.authStore.profile;
    const data = {
      email: deal.lm_contact.email,
      first_name: deal.lm_contact.first_name,
      mobile: deal.lm_contact.mobile,
      student_first_name: deal.lm_contact.student_first_name,
      deal_id: deal.id,
      m1_booking_user: profile.email,
      booking_from: booking_from,
      redirect_url: window.location,
      region: deal.region || deal.lm_contact.region
    };
    const params = queryString.stringify(data);
    const url = `${process.env.REACT_APP_BOOKING_URL}?${params}`;
    window.open(url, "_blank");
  };

  tcsPresented = async note => {
    const deal = this.deal;
    return TrialCoachingSessionsService.takeAction("mark_presented", deal.id, {
      note: note
    }).then(response => {
      Alert.success("Confirmed presented");
      this.handleDealUpdate(response);
      return response;
    });
  };

  tcsReschedule = (create_new_deal, assign_deal_to_me, admin_resheduling) => {
    const deal = this.deal;
    const profile = this.authStore.profile;
    const data = {
      region: deal.region || deal.lm_contact.region,
      email: deal.lm_contact.email,
      first_name: deal.lm_contact.first_name,
      mobile: deal.lm_contact.mobile,
      student_first_name: deal.lm_contact.student_first_name,
      deal_id: deal.id,
      m1_booking_user: profile.email,
      booking_from: deal.booking_from,
      business_stream: deal.business_stream,
      redirect_url: window.location,
      help: "reschedule",
      create_new_deal: create_new_deal,
      assign_deal_to_me: assign_deal_to_me,
      admin_resheduling: admin_resheduling
    };
    const params = queryString.stringify(data);
    const url = `${process.env.REACT_APP_BOOKING_URL}?${params}`;
    window.open(url, "_blank");
  };

  undoPresentation = () => {
    const deal = this.deal;
    TrialCoachingSessionsService.takeAction("undo_presentation", deal.id).then(
      response => {
        Alert.success("TCS presentation was undone");
        this.handleDealUpdate(response);
      }
    );
  };

  undoNoSale = () => {
    const deal = this.deal;
    TrialCoachingSessionsService.takeAction("undo_nosale", deal.id).then(
      response => {
        Alert.success("TCS no sale was undone");
        this.handleDealUpdate(response);
      }
    );
  };

  undoAttendeeConfirmation = () => {
    const deal = this.deal;
    TrialCoachingSessionsService.takeAction(
      "undo_attendee_confirmation",
      deal.id
    ).then(response => {
      Alert.success("TCS attendee confirmation was undone");
      this.handleDealUpdate(response);
    });
  };

  undoDeadDeal = () => {
    const deal = this.deal;
    TrialCoachingSessionsService.takeAction("undo_deal_deal", deal.id).then(
      response => {
        Alert.success("TCS dead deal was undone - deal is active now");
        this.handleDealUpdate(response);
      }
    );
  };
}
export default TCSActions;
